import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {CONTACTUS} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import ContactUsWidget from '@components/Static/Contact';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import dynamic from 'next/dynamic';
import {isCSR} from '@jobseeker/lotus/utils';
import {AppState} from '@jobseeker/common-core/types';
import {InjectSearchOverlay} from '@components';
import type {GetServerSidePropsContext} from 'next/types';

type ContactUsProps = {
  seoConfig: object;
  isMobile?: boolean;
};
const HiristAuthentication = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/HiristAuthenticationHarness/AuthForm'
    ),
  {
    ssr: false,
  }
);

const ContactUs = ({seoConfig, isMobile}: ContactUsProps) => {
  const metaData = getConfigByApp(metaInfo, CONTACTUS, true, CONTACTUS);
  const {searchOverlay, enableLoginPopup} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isSearchEnabled = useSelector(() => searchOverlay, shallowEqual);
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const breadcrumbElements: {name: string; item: string}[] = [];
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const onLoginSuccess = () => {
    if (isCSR()) {
      window.location.reload();
    }
  };

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && (
            <HiristAuthentication
              variant={VersionVariants.VERSION_TWO}
              onSuccess={onLoginSuccess}
              openDialog={enableLoginPopup}
              setOpenDialog={() => {
                dispatch({
                  type: 'AppContext/set_login_popup',
                  payload: false,
                });
              }}
            />
          )}
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
          <ContactUsWidget isMobile={isMobile} />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const seoConfig = await loadSEO(CONTACTUS);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: CONTACTUS},
    });

    const {isMobile} = utilServerSideDeviceDetection(context);

    return {
      props: {
        seoConfig,
        isMobile,
      },
    };
  }
);

export default ContactUs;
